import * as React from 'react';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import GridMenu from '@com/tool-bar/menu/grid-menu';
import { DEFAULT_ITEM_SYMBOL_TYPE } from '@src/framework/editor/src/js/constants/toolbar-data';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';

/**
 * 网格面板，用于项目符号、数字符号等
 */
export default class BaseGridFeature extends BaseDrawerFeature {
    constructor() {
        super();
    }

    public onClick(isDrawer?: boolean) {
        let index = this.getSelectedIndex();
        if (index >= 1) {
            index = 0;
        }  else {
            index = this.getDefaultIndex();
        }
        const { dropdown } = this.config;
        // todo: 拆到每个类型下
        if (this.id === ActionType.BORDERSTYLE) {
            isDrawer ? this.drawerCallback(index) : this.callback(index);
        } else {
            if (!dropdown) return;
            const itemData = this.getDropdownData(dropdown)[index];
            isDrawer ? this.drawerCallback(itemData.id) : this.callback(itemData.id);
        }
    }

    /**
     * 获取不同面板的样式
     * @param dropdown
     * todo: 拆到每个类型下
     */
    public getDefaultStyle(dropdown) {
        if (this.id === ActionType.ITEMNUMBER) {
            dropdown.itemWidth = 60;
            dropdown.itemHeight = 80;
            dropdown.itemPadding = 0;
            dropdown.showBorder = true;
        } else if (this.id === ActionType.DIGITNUMBER) {
            dropdown.itemWidth = 60;
            dropdown.itemHeight = 80;
            dropdown.itemPadding = 0;
            dropdown.showBorder = true;
        } else if (this.id === ActionType.INDENT) {
            dropdown.itemWidth = 70;
            dropdown.itemHeight = 32;
            dropdown.itemPadding = 4;
            dropdown.showBorder = false;
        } else if (this.id === ActionType.INSERT_FORM) {
            dropdown.itemWidth = 12;
            dropdown.itemHeight = 12;
            dropdown.itemPadding = 0;
            dropdown.showBorder = true;
        } else if (this.id === ActionType.HORIZONTAL_ALIGN || this.id === ActionType.VERTICAL_ALIGN) {
            dropdown.itemWidth = 32;
            dropdown.itemWidth = 70;
            dropdown.itemHeight = 32;
            dropdown.itemPadding = 4;
            dropdown.itemPadding = '4px 23px';
            dropdown.showBorder = false;
        } else {
            dropdown.itemWidth = 32;
            dropdown.itemHeight = 32;
            dropdown.itemPadding = 4;
            dropdown.showBorder = false;
        }
    }

    // todo: 同上，拆到每个类型下
    public handleMenuClick = (index, isDrawer?: boolean) => {
        const { dropdown } = this.config;
        if (this.id === ActionType.BORDERSTYLE) {
            isDrawer ? this.drawerCallback(index) : this.callback(index);
        } else {
            if (!dropdown) return;
            const itemData = this.getDropdownData(dropdown)[index];
            isDrawer ? this.drawerCallback(itemData.id) : this.callback(itemData.id);
        }
    };

    /**
     * 下拉展示的获取网格面板
     */
    public showContent(useStyle?: boolean, isDrawer?: boolean) {
        let { dropdown } = this.config;
        if (!dropdown) return <div />;
        dropdown = this.setDisabledForDropdownData(dropdown);
        const value = this.getItemValue();
        this.getDefaultStyle(dropdown);
        const selectedIndex = this.getSelectedIndex();
        const { checkSelectedValue } = dropdown;
        const style = useStyle ? {
            background: 'hsla(0, 0%, 100%)',
            transform: 'scaleX(1) translate(0)',
            padding: '8px 0',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            borderRadius: '4px',
        } : {};
        const bottomSlot = this.getBottomSlot();
        // onMouseDown 处理wb的抢焦问题
        return <div
            onMouseDown={(event) => {
                event.preventDefault();
            }} style={style}>
            <GridMenu
                {...dropdown}
                checkSelectedValue={checkSelectedValue}
                id={this.id}
                selectedIndex={selectedIndex}
                menuValue={value}
                hideMenu={() => {}}
                onMenuClick={index => this.handleMenuClick(index, isDrawer)}
                menuManager={this.getMenuManager()}
                selectionService={this.getSelectionService()}
            />
            {
                bottomSlot
            }
        </div>;
    }

    /**
     * 获取选中项的索引
     * @private
     */
    public getSelectedIndex() {
        let index = -1;
        const { dropdown } = this.config;
        if (!dropdown) return index;
        const value = this.getItemValue();

        if (dropdown.checkSelectedValue) {
            this.getDropdownData(dropdown).forEach((item, i) => {
                if (value === item.id) {
                    index = i;
                }
            });
        }
        return index;
    }

    /**
     * 获取选中的icon
     */
    public getSelectedIcon() {
        let icon = '';
        const index = this.getSelectedIndex();
        const { dropdown } = this.config;
        if (!dropdown) return icon;
        if (dropdown.checkSelectedValue && index >= 0) {
            icon = this.getDropdownData(dropdown)[index].icon;
        }
        return icon;
    }

    /**
     * 获取底部元素插槽
     * @returns
     */
    public getBottomSlot(): React.ReactNode | null {
        return null;
    }

    /**
     * 查找网格内部子项有没有禁用
     */
    private setDisabledForDropdownData(dropdown) {
        const disableItems = this.getAppService().editableServiceLayer?.menuManager.disableItemIds() || [];
        return {
            ...dropdown,
            data: this.getDropdownData(dropdown).map((dataItem) => {
                const { id } = dataItem;
                return {
                    ...dataItem,
                    disabled: disableItems.find(item => item.id === id),
                };
            }),
        };
    }

    /**
     * 获取默认选项的索引
     * 项目符号默认选项是最后一个小圆点
     * @returns
     */
    private getDefaultIndex() {
        if (this.id === ActionType.ITEMNUMBER) {
            const { dropdown } = this.config;
            const data = this.getDropdownData(dropdown);
            if (data) {
                const index = data.findIndex(item => item.id === DEFAULT_ITEM_SYMBOL_TYPE);
                if (index !== -1) {
                    return index;
                }
            }
        }
        return 1;
    }

    private getDropdownData(dropdown) {
        return dropdown.data || dropdown.getData() || [];
    }
}
